import React from 'react';
import { ErrorState as BaseErrorState } from '../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { MESSAGES } from '../../../../CommonConstants';
import { isOptedIn } from '../../../../CommonUtils/isOptedIn';

interface Props {
  clientId: string;
  error: Error | null;
  refetch(): void;
}

export const ErrorState = ({ clientId, error, refetch }: Props) => {
  if (error?.message === MESSAGES.GENERIC_ERROR) {
    return <BaseErrorState height="100%" onAction={refetch} message={error?.message} />;
  }

  const hasAccessToEditFinancialPlan = isOptedIn('EditFinancialPlan');
  const hasNoGoals = /add a valid goal/i.test(error?.message || '');

  return (
    <BaseErrorState
      height="100%"
      title="Some information is Missing."
      message={error?.message}
      {...(hasAccessToEditFinancialPlan && hasNoGoals
        ? {
            onAction: () => ADV.util.Router.go2('ClientEditPlan', { clientId }),
            actionTitle: 'Edit Financial Plan',
          }
        : {})}
    />
  );
};
